import { 
    GET_INDIVIDUAL,
    GET_INDIVIDUAL_SUCCESS,
    GET_INDIVIDUAL_FAIL,
    GET_PROFILE,
    GET_PROFILE_SUCCESS,
    GET_PROFILE_FAIL,
    GET_VEHICLE_TYPE,
    GET_VEHICLE_TYPE_SUCCESS,
    GET_VEHICLE_TYPE_FAIL,
    GET_DELIVERY_AREAS,
    GET_DELIVERY_AREAS_SUCCESS,
    GET_DELIVERY_AREAS_FAIL,
    GET_INDIVIDUAL_DOCUMENT,
    GET_INDIVIDUAL_DOCUMENT_SUCCESS,
    GET_INDIVIDUAL_DOCUMENT_FAIL,
    GET_CITY_LIST,
    GET_CITY_LIST_SUCCESS,
    GET_CITY_LIST_FAIL,
    GET_REVIEW_COUNT,
    GET_REVIEW_COUNT_SUCCESS,
    GET_REVIEW_COUNT_FAIL,
    GET_PROVINCE_COUNTRY_BY_WAREHOUSE,
    GET_PROVINCE_COUNTRY_BY_WAREHOUSE_SUCCESS,
    GET_PROVINCE_COUNTRY_BY_WAREHOUSE_FAIL,
    GET_FUEL_TYPE,
    GET_FUEL_TYPE_SUCCESS,
    GET_FUEL_TYPE_FAIL
} from '../actions/types';

const initialState = {
    getIndividualLoading: false,
    getIndividual: {},
    getIndividualError: false,
    getProfileLoading: false,
    getProfile: {},
    getProfileError: false,
    getVehicleTypeLoading: false,
    getVehicleType: {},
    getVehicleTypeError: false,
    getFuelTypeLoading: false,
    getFuelType: {},
    getFuelTypeError: false,
    getDeliveryAreasLoading: false,
    getDeliveryAreas: {},
    getDeliveryAreasError: false,
    getIndividualDocumentLoading: false,
    getIndividualDocument: [],
    getIndividualDocumentError: false,
    getCityListLoading: false,
    getCityList: [],
    getCityListError: false,
    getReviewCountLoading: false,
    getReviewCount: {},
    getReviewCountError: false,
    getProvinceCountryByWarehouseLoading: false,
    getProvinceCountryByWarehouse: [],
    getProvinceCountryByWarehouseError: false
}

export default function driverAppApprocalReducer(state = initialState, action){
    switch(action.type){
        case GET_INDIVIDUAL:
            return {
                ...state,
                getIndividualLoading: true,
            }
        case GET_INDIVIDUAL_SUCCESS:
            return {
                ...state,
                getIndividual: action.payload,
                getIndividualLoading: false
            }
        case GET_INDIVIDUAL_FAIL:
            return {
                ...state,
                getIndividualLoading: false,
                getIndividualError: action.payload
            }
        case GET_PROFILE:
            return {
                ...state,
                getProfileLoading: true,
            }
        case GET_PROFILE_SUCCESS:
            return {
                ...state,
                getProfile: action.payload,
                getProfileLoading: false
            }
        case GET_PROFILE_FAIL:
            return {
                ...state,
                getProfileLoading: false,
                getProfileError: action.payload
            }
        case GET_VEHICLE_TYPE:
            return {
                ...state,
                getVehicleTypeLoading: true,
            }
        case GET_VEHICLE_TYPE_SUCCESS:
            return {
                ...state,
                getVehicleType: action.payload,
                getVehicleTypeLoading: false
            }
        case GET_VEHICLE_TYPE_FAIL:
            return {
                ...state,
                getVehicleTypeLoading: false,
                getVehicleTypeError: action.payload
            }
        case GET_FUEL_TYPE:
            return {
                ...state,
                getFuelTypeLoading: true,
            }
        case GET_FUEL_TYPE_SUCCESS:
            return {
                ...state,
                getFuelType: action.payload,
                getFuelTypeLoading: false
            }
        case GET_FUEL_TYPE_FAIL:
            return {
                ...state,
                getFuelTypeLoading: false,
                getFuelTypeError: action.payload
            }
        case GET_DELIVERY_AREAS:
            return {
                ...state,
                getDeliveryAreasLoading: true,
            }
        case GET_DELIVERY_AREAS_SUCCESS:
            return {
                ...state,
                getDeliveryAreas: action.payload,
                getDeliveryAreasLoading: false
            }
        case GET_DELIVERY_AREAS_FAIL:
            return {
                ...state,
                getDeliveryAreasLoading: false,
                getDeliveryAreasError: action.payload
            }
        case GET_INDIVIDUAL_DOCUMENT:
            return {
                ...state,
                getIndividualDocumentLoading: true,
            }
        case GET_INDIVIDUAL_DOCUMENT_SUCCESS:
            return {
                ...state,
                getIndividualDocument: action.payload,
                getIndividualDocumentLoading: false
            }
        case GET_INDIVIDUAL_DOCUMENT_FAIL:
            return {
                ...state,
                getIndividualDocumentLoading: false,
                getIndividualDocumentError: action.payload
            }
        case GET_CITY_LIST:
            return {
                ...state,
                getCityListLoading: true,
            }
        case GET_CITY_LIST_SUCCESS:
            return {
                ...state,
                getCityList: action.payload,
                getCityListLoading: false
            }
        case GET_CITY_LIST_FAIL:
            return {
                ...state,
                getCityListLoading: false,
                getCityListError: action.payload
            }
        case GET_REVIEW_COUNT:
            return {
                ...state,
                getReviewCountLoading: true,
            }
        case GET_REVIEW_COUNT_SUCCESS:
            return {
                ...state,
                getReviewCount: action.payload,
                getReviewCountLoading: false
            }
        case GET_REVIEW_COUNT_FAIL:
            return {
                ...state,
                getReviewCountLoading: false,
                getReviewCountError: action.payload
            }
        case GET_PROVINCE_COUNTRY_BY_WAREHOUSE:
            return {
                ...state,
                getProvinceCountryByWarehouseLoading: true,
            }
        case GET_PROVINCE_COUNTRY_BY_WAREHOUSE_SUCCESS:
            return {
                ...state,
                getProvinceCountryByWarehouse: action.payload,
                getProvinceCountryByWarehouseLoading: false
            }
        case GET_PROVINCE_COUNTRY_BY_WAREHOUSE_FAIL:
            return {
                ...state,
                getProvinceCountryByWarehouseLoading: false,
                getProvinceCountryByWarehouseError: action.payload
            }
        default:
            return state;
    }
}